import { ReactElement } from 'react';
import { UIText } from '../ui-text';
import styles from './ui-tags.module.scss';

export type UITagProps = { text: string };
export function UITag(props: UITagProps): ReactElement {
    const { text } = props;

    return (
        <div className={styles.tag}>
            <UIText variant="small" type={'default2'}>
                {text}
            </UIText>
        </div>
    );
}

type UITagGroupProps = { tags: UITagProps[] };
export function UITagGroup(props: UITagGroupProps): ReactElement {
    const { tags } = props;

    return (
        <div className={styles.tags}>
            {tags.map((tag, index) => (
                <UITag {...tag} key={index} />
            ))}
        </div>
    );
}
